import { useState } from "react";
import { post } from "../http/api";
import { useTranslation } from "react-i18next";

import {
    FaFilePdf,
    FaSpinner
}
    from "react-icons/fa";

import "./ApplyOfferModal.css";

export default function ApplyOfferModal({

    open,
    onClose,
    offerId

}) {

    const { t } = useTranslation();

    const [files, setFiles] = useState({});
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const [errors, setErrors] = useState({});
    const [feedback, setFeedback] = useState(null);

    const [feedbackType, setFeedbackType] = useState("");

    if (!open)
        return null;


    const upload = (e, type) => {

        setFiles({

            ...files,

            [type]:
                e.target.files[0]

        });

    };


    const apply = async () => {

        let newErrors = {};

        if (!message.trim()) {

            newErrors.message =
                t("applyOffer.errors.messageRequired");

        }

        if (!files.cv) {

            newErrors.cv =
                t("applyOffer.errors.cvRequired");

        }

        setErrors(
            newErrors
        );

        if (
            Object.keys(
                newErrors
            ).length > 0
        ) {

            return;

        }

        try {

            setLoading(true);

            const form =
                new FormData();

            form.append(
                "message",
                message
            );

            form.append(
                "cv",
                files.cv
            );

            const response = await post(

                `offers/${offerId}/apply`,
                form,

                {
                    headers: {
                        "Content-Type":
                            "multipart/form-data"
                    }
                }

            );


            /* vérifier la réponse backend */

            const msg =
                response?.message;


            if (
                msg === "ALREADY_APPLIED"
            ) {

                setFeedback(
                    t("applyOffer.feedback.alreadyApplied")
                );

                setFeedbackType(
                    "error"
                );

                return;

            }

            if (
                msg === "SPORT_CV_REQUIRED"
            ) {

                setFeedback(
                    t("applyOffer.errors.cvRequired")
                );

                setFeedbackType(
                    "error"
                );

                return;

            }


            if (
                msg === "MESSAGE_REQUIRED"
            ) {

                setFeedback(
                    t("applyOffer.errors.messageRequired")
                );

                setFeedbackType(
                    "error"
                );

                return;

            }


            if (
                msg === "APPLICATION_SENT"
            ) {

                setFeedback(
                    t("applyOffer.feedback.applicationSent")
                );

                setFeedbackType(
                    "success"
                );

                setTimeout(() => {

                    onClose();

                }, 1500);

            }

            setTimeout(() => {

                onClose();

            }, 1500);

        }
        catch (err) {

            setFeedback(
                t("applyOffer.feedback.alreadyApplied")
            );

            setFeedbackType(
                "error"
            );

        }
        finally {

            setLoading(false);

        }

    };


    return (

        <div
            className="apply-overlay"
            onClick={() =>
                !loading &&
                onClose()
            }
        >

            <div
                className="apply-modal"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >

                <h2>
                    {t("applyOffer.title")}
                </h2>

                <p>
                    {t("applyOffer.subtitle")}
                </p>


                <textarea
                    placeholder={
                        t("applyOffer.placeholders.message")
                    }
                    value={message}
                    onChange={(e) => {
                        setMessage(
                            e.target.value
                        );
                        setErrors({

                            ...errors,
                            message: null
                        });
                    }}

                ></textarea>


                {errors.message && (

                    <div className="offer-field-error">

                        {errors.message}

                    </div>

                )}


                <div className="upload-grid">

                    <label
                        className={
                            files.cv
                                ?
                                "active-upload"
                                :
                                ""
                        }
                    >

                        <FaFilePdf />

                        <span>

                            {files.cv

                                ?

                                t(
                                    "applyOffer.upload.selected",
                                    {
                                        filename: files.cv.name
                                    }
                                )

                                :

                                t("applyOffer.upload.sportCv")

                            }

                        </span>

                        <input

                            hidden
                            type="file"
                            accept=".pdf"
                            required
                            onChange={(e) =>

                                upload(
                                    e,
                                    "cv"
                                )

                            }

                        />

                    </label>

                </div>

                {errors.cv && (

                    <div className="offer-field-error">

                        {errors.cv}

                    </div>

                )}


                {
                    feedback && (

                        <div
                            className={`feedback ${feedbackType}`}
                        >

                            {feedback}

                        </div>

                    )
                }


                <div
                    className="apply-buttons"
                >

                    <button

                        disabled={loading}

                        onClick={onClose}

                    >
                        {t("applyOffer.buttons.cancel")}
                    </button>


                    <button

                        disabled={loading}

                        className="send-btn"

                        onClick={apply}

                    >

                        {loading ?

                            <>

                                <FaSpinner
                                    className="spin"
                                />

                                {t("applyOffer.buttons.sending")}

                            </>

                            :
                            t("applyOffer.buttons.send")
                        }

                    </button>

                </div>

            </div>

        </div>

    )

}